/**
 * Envoltorio sobre gtag (cargado en public/index.html). Si el script no llegó
 * a cargar (bloqueador de anuncios, sin conexión), la llamada no rompe el sitio.
 *
 * Cuando tengan el ID de conversión de Google Ads (AW-XXXXXXXXXX/etiqueta),
 * alcanza con agregar acá un segundo gtag("event", "conversion", {...}) para
 * los eventos que deban contar como conversión — no hace falta tocar los
 * componentes que ya llaman a trackEvent.
 */
export const trackEvent = (name, params = {}) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};
